import script from "./ProfileDropDown.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileDropDown.vue?vue&type=script&setup=true&lang=js"

import "./ProfileDropDown.vue?vue&type=style&index=0&id=22766f24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22766f24"]])

export default __exports__